/// <reference path="../../typings/browser.d.ts" />

import IDeviceAlarmConfig = Application.Models.IDeviceAlarmConfig;

namespace Application.Controllers {
    'use strict';

    import IPaginatedList = Models.IPaginatedList;
    import INetworkNode = Models.INetworkNode;
    import IAlarmConfigs = Models.IDeviceAlarmConfig;
    import IEntity = Models.IEntity;
    import IConditionAlarmConfigMap = Models.IConditionAlarmConfigMap;

    interface IAlarmsServicesRouteParamsService extends ng.route.IRouteParamsService {
        serviceId: string;
    }

    interface IFlexService extends IEntity {
        name: string;
        status: string;
    }

    export class AdminAlarmsServicesController {
        public static $name: string = "adminAlarmsServicesController";
        public static $inject: string[] = ['$routeParams',
                                           'alarmsService',
                                           ];

        public device: IEntity;
        public networkNodes: IPaginatedList<INetworkNode>;
        public conditionKeys: string[];
        public conditionAlarmConfigMap: IConditionAlarmConfigMap = {};
        public conditionAlarmConfigCopyMap: IConditionAlarmConfigMap = {};
        public selectedCondition: string;
        public errorsMap: string[];

        private services: IFlexService[];

        constructor($routeParams: IAlarmsServicesRouteParamsService,
                    private alarmsService: Services.AlarmsService) {

            this.services = [
                {
                    href: "flexServices/sonadapter",
                    name: "SON Adapter",
                    status: "Online", // TODO: Check in consul
                },
                {
                    href: "flexServices/mvpadapter",
                    name: "MVP Adapter",
                    status: "Online",
                },
                {
                    href: "flexServices/flexcollector",
                    name: "Flex Collector",
                    status: "Online",
                },
                {
                    href: "flexServices/flexauth",
                    name: "Flex Auth",
                    status: "Online",
                },
                {
                    href: "flexServices/nevionadapter",
                    name: "Nevion Adapter",
                    status: "Online",
                },
                {
                    href: "flexServices/atemesnmpadapter",
                    name: "Ateme SNMP Adapter",
                    status: "Online",
                },
            ];
            let serviceId: string = $routeParams.serviceId;
            if (serviceId) {
                let [theService]: IFlexService[] = this.services.filter((service: IFlexService) => {
                     return service.href === "flexServices/" + serviceId;
                });
                if (theService) {
                    this.device = theService;
                    this.loadDeviceAlarmConfig();
                }

            }
        }

        public alarmsHaveBeenChanged(): boolean {
            let copy: IAlarmConfigs = this.getCurrentDeviceAlarmConfigCopy();
            let orig: IAlarmConfigs = this.getCurrentDeviceAlarmConfig();
            if (Common.Utils.exists(orig) && Common.Utils.exists(copy)) {
                this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
                return this.alarmsService.alarmsHaveBeenChanged(orig.alarmConfigs, copy.alarmConfigs);
            } else {
                return false;
            }
        }

        public changeMaskParam(alarmConfig: Models.IAlarmConfig): void {
            if (this.device !== undefined) {
                alarmConfig.masked = !alarmConfig.masked;
            }
        };

        public changeMaskLevel(alarmConfig: Models.IAlarmConfig, index: number): void {
            if (this.device !== undefined) {
                if ((alarmConfig.type as string) === 'relay' ||
                    (Common.Utils.exists(alarmConfig.levels[index].value) && alarmConfig.levels[index].value !== ''))
                    alarmConfig.levels[index].masked = !alarmConfig.levels[index].masked;
            }
        };

        public discardChanges(): void {
            this.conditionAlarmConfigCopyMap[this.selectedCondition].alarmConfigs =
                angular.copy(this.getCurrentDeviceAlarmConfig().alarmConfigs);
        }

        public saveChanges(): void {
            let copy: IAlarmConfigs = this.getCurrentDeviceAlarmConfigCopy();
            this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
            if (!this.errorsMap) {
                this.alarmsService
                    .saveAlarmConfigs(copy)
                    .then((alarmConfig: IAlarmConfigs) => {
                        this.conditionAlarmConfigMap[alarmConfig.condition] = alarmConfig;
                        this.conditionAlarmConfigCopyMap[alarmConfig.condition] = Common.Utils.clone(alarmConfig) as IDeviceAlarmConfig;
                    });
            }
        }

        public getSeverityColor(severity: number): string {
            return this.alarmsService.getSeverityColor(severity);
        }

        public escapeId(paramName: string): string {
            return this.selectedCondition + "_" + paramName.replace(/\[/g, "_").replace(/\]/g, "_").replace(/\./g, "_");
        }

        private loadDeviceAlarmConfig(): void {
            this.alarmsService.getAlarmConfigsByHref(this.device.href)
                .then((alarmConfigs: IAlarmConfigs[]) => {
                    this.selectAlarmConfigForCondition(alarmConfigs);
                });
        }

        private selectAlarmConfigForCondition(alarmConfigs: IDeviceAlarmConfig[]): void {
            this.conditionAlarmConfigMap = {};
            this.conditionAlarmConfigCopyMap = {};
            alarmConfigs.forEach((deviceAlarmConfig: IDeviceAlarmConfig) => {
                this.conditionAlarmConfigMap[deviceAlarmConfig.condition] = deviceAlarmConfig;
                this.conditionAlarmConfigCopyMap[deviceAlarmConfig.condition] = Common.Utils.clone(deviceAlarmConfig) as IDeviceAlarmConfig;
            });
            this.conditionKeys = Object.keys(this.conditionAlarmConfigMap);
            this.selectedCondition = "operation";
        }

        private getCurrentDeviceAlarmConfig(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigMap[this.selectedCondition];
        }

        private getCurrentDeviceAlarmConfigCopy(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigCopyMap[this.selectedCondition];
        }

        private setMailAlert(alarmConfig: Models.IAlarmConfig, index: number): void {
            console.log("Services alarms")
            if (!alarmConfig.levels[index].masked && !alarmConfig.masked) {
                alarmConfig.levels[index].emailAlert = !alarmConfig.levels[index].emailAlert;
            }
        }
    }
}

